import React, { useMemo } from "react";

//Components
import Autocomplete from "../Autocomplete";

const options = [
    {
        label: 'Si',
        value: 'true'
    },
    {
        label: 'No',
        value: 'false'
    }
]

const AutocompleteBolean = ({ name, value, ...rest }) => {
    const option = useMemo(() => {
        if (!value) return '';

        return options.find(o => o.value === value);
    }, [value])

    return (
        <Autocomplete
            fullWidth
            name={name}
            {...rest}
            value={option}
            options={options}
            isOptionEqualToValue={(option, value) => option.value === value}
            data-testid={`${name}-autocomplete`}
        />
    );
}

export default AutocompleteBolean;